<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <router-link
              :to="{ path: '/ReturnOrders/Create' }"
              class="vs-component vs-button bg_l_green"
              v-has-permission="permission22"
            >
              <feather-icon
                icon="PlusIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />{{ $t("ReturnOrders") }}
            </router-link>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('OrderId'), sort: 'OrderId' },
                { title: $t('OperatorName'), sort: 'OperatorName' },
                { title: $t('PartyName'), sort: 'PartyName' },
                { title: $t('TotalAmount'), sort: 'TotalAmount' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Action') }
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 15%">
                  {{ row.orderId }}
                </td>
                <td style="width: 20%">
                  <span v-if="row.returnOrderSaleOperatorQuery != null">
                    {{ row.returnOrderSaleOperatorQuery.saleOperatorName }}
                  </span>
                  <span v-if="row.returnOrderSaleOperatorQuery == null">
                    -
                  </span>
                </td>
                <td style="width: 20%">
                  {{ row.returnOrderPartyInfoQueryDto.name }}
                </td>
                <td style="width: 15%">
                  {{ Number(row.totalAmountForPayment).toLocaleString() }} ریال
                </td>
                <td style="width: 15%; direction: ltr">
                   {{ row.createOn.split(" ")[0] }}<br />{{
                  row.createOn.split(" ")[1]
                }}
                </td>
                <td style="width: 15%">
                  <router-link
                    :to="{ path: '/ReturnOrders/Details/' + row.id }"
                  >
                    <vs-button
                      radius
                      color="success"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="ml-4 d-inline"
                      v-has-permission="permission23"
                    ></vs-button>
                  </router-link>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  name: "saleManagement_ReturnOrders_Index",
  components: {
    DataGrid
  },
  data() {
    return {
      permission23: "",
      permission22: "",
      ModifyPopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "Sales/api/ReturnOrdersQuery"
      },
      gridSearchData: {
        keyword: ""
      }
    };
  }
};
</script>
